import { produce } from 'immer';
import { Action, createAsyncAction, createReducer } from 'typesafe-actions';
import type { ReduxError } from '@universal/errors';

export type GetIdpCountryResponse = {
  countryName: string;
  additionalInfo: string;
};

export enum Actions {
  GET_IDP_COUNTRIES = 'naf/idpCountries/GET_IDP_COUNTRIES',
  GET_IDP_COUNTRIES_SUCCESS = 'naf/idpCountries/GET_IDP_COUNTRIES_SUCCESS',
  GET_IDP_COUNTRIES_FAIL = 'naf/idpCountries/GET_IDP_COUNTRIES_FAIL',
  GET_IDP_COUNTRIES_CANCEL = 'naf/idpCountries/GET_IDP_COUNTRIES_CANCEL',
}

export interface State {
  data: { countryName: string; additionalInfo: string }[];
  isUpdating: boolean;
  errorState?: any;
}

export const initialState: State = {
  data: [],
  isUpdating: false,
};

export const actions = {
  getIdpCountries: createAsyncAction(
    Actions.GET_IDP_COUNTRIES, // request payload creator
    Actions.GET_IDP_COUNTRIES_SUCCESS, // success payload creator
    Actions.GET_IDP_COUNTRIES_FAIL, // failure payload creator
    Actions.GET_IDP_COUNTRIES_CANCEL, // optional cancel payload creator
  )<undefined, GetIdpCountryResponse[], ReduxError, undefined>(),
};

export const reducers = createReducer<State, Action>(initialState, {})
  .handleAction(actions.getIdpCountries.request, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.isUpdating = true;
    }),
  )
  .handleAction(actions.getIdpCountries.success, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.isUpdating = false;
      draftState.data = action.payload;
    }),
  )
  .handleAction(actions.getIdpCountries.failure, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.isUpdating = false;
      draftState.errorState = action.payload;
    }),
  )
  .handleAction(actions.getIdpCountries.cancel, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.isUpdating = false;
    }),
  );
